import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/customers").then(r=>setList(r.data)); }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-10">
      <p className="overline text-berulia-rosedeep">BERULIA</p>
      <h1 className="font-heading text-3xl sm:text-4xl mt-2 mb-8">Clientes</h1>
      <div className="bg-white border border-berulia-border overflow-x-auto">
        <table className="w-full text-sm whitespace-nowrap">
          <thead className="bg-berulia-beigewarm"><tr><th className="text-left p-3">Nom</th><th className="text-left p-3">Email</th><th className="text-left p-3">Téléphone</th><th className="text-left p-3">Inscrite le</th></tr></thead>
          <tbody>
            {list.map(c => (
              <tr key={c.id} className="border-t border-berulia-border"><td className="p-3">{c.first_name} {c.last_name}</td><td className="p-3">{c.email}</td><td className="p-3">{c.phone || "—"}</td><td className="p-3">{new Date(c.created_at).toLocaleDateString("fr-FR")}</td></tr>
            ))}
            {list.length===0 && <tr><td colSpan={4} className="p-8 text-center text-berulia-inkmuted">Aucune cliente.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
